import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getInquiryResponse, getPrintInquiryResponse } from '@api/inquiries';
import { getMedicationResponseDetails } from '@api/medications';
import {
  getSupplementResponseDetails,
  getUserEnteredSupplementDetails,
  markSupplementResponseAsViewed,
  submitSupplementNeedsInfoForm,
} from '@api/supplements';
import { IInquiryResponse, IPrintInquiryResponse } from '@interfaces/inquiries';
import { IMedicationResponseDetails } from '@interfaces/medications';
import {
  ISubmitSupplementNeedsInfoFormPayload,
  ISupplementResponseDetails,
  IUserEnteredSupplement,
} from '@interfaces/supplements';

export const handleGetInquiryResponse = createAsyncThunk<AxiosResponse<IInquiryResponse>, number>(
  'getInquiryResponse',
  getInquiryResponse,
);

export const handleGetPrintInquiryResponse = createAsyncThunk<
  AxiosResponse<IPrintInquiryResponse>,
  number
>('getPrintInquiryResponse', getPrintInquiryResponse);

export const handleGetSupplementResponseDetails = createAsyncThunk<
  AxiosResponse<ISupplementResponseDetails>,
  number
>('getSupplementResponseDetails', getSupplementResponseDetails);

export const handleMarkSupplementResponseAsViewed = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  number
>('markSupplementResponseAsViewed', markSupplementResponseAsViewed);

export const handleGetUserEnteredSupplement = createAsyncThunk<
  AxiosResponse<IUserEnteredSupplement>,
  number
>('getUserEnteredSupplement', getUserEnteredSupplementDetails);

export const handleSubmitSupplementNeedsInfoForm = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  ISubmitSupplementNeedsInfoFormPayload
>('submitSupplementNeedsInfoForm', submitSupplementNeedsInfoForm);

export const handleGetMedicationResponseDetails = createAsyncThunk<
  AxiosResponse<IMedicationResponseDetails>,
  number
>('getMedicationResponseDetails', getMedicationResponseDetails);
